import "../assets/styles/style.css";

export default function Footer() {
    return (
      <div className="footer">
        <h3>By Leonan Marinho</h3>
      </div>
    );
  }
